import { defineMessages } from 'react-intl';

export default defineMessages({
  optionTitleLeft: { defaultMessage: 'All' },
  optionTitleRight: { defaultMessage: 'Stable Coins' },
  total: { defaultMessage: 'Total' },

  changeMarket: { defaultMessage: 'Can’t find your asset? {button}' },
});
